export const environment = {
  production: true,
  envName: 'mvp',
  apiBaseUrl: 'https://api.fuga-control.com/api/v1',
  wsBaseUrl: 'https://api.fuga-control.com',
  domainSuffix: 'fuga-control.com',
  googleMapsApiKey: '__SET_AT_BUILD__',
  sentryDsn: '',
};
